import {computed} from 'vue';
import json_gamma from '../json/taula_gamma.json'
import json_gamma_universitaria from '../json/taula_gamma_universitaria.json'


export default function castell(notacio, uni=false){

let etiqueta = ``
let normalitzat = []


/* const validaCastell=computed(()=>{
//Comprovar que l'entrada encaixa amb Estructura + d + Pisos + Modificadors + Resultat
const lectura = notacio.match(/^([PpTtVv\d]+)(?:d|de)(\d+)([a-zA-Z]*)(\([a-zA-Z]*\))?$/)

if (lectura){
    const valorEstructura =(
    ["T","t","P","p","V","v","2","3","4","5","6","7","8","9","10","12"].includes(lectura[1])
    ||lectura[1].match(/^(\d+)([Pp])$/)
)
    &&parseInt(lectura[2])<11; 
    console.log(valorEstructura)
    etiqueta = lectura[1]+"d"+lectura[2]+lectura[3] 
    
    //[0]Complet [1]Estructura + [2]Pisos + [3]Modificadors + [4]Resultat
    normalitzat=lectura
    //Comprovar que la estructura sigui un caracter valid i els pisos son correctes
    for (let i=0;i<normalitzat.length;i++){
        if (normalitzat[i]==undefined){
            normalitzat[i]=""
        }
    }
    if (valorEstructura){
        //Normalitzar nomencaltura
        //Si es fa servir la nomenclatura de Torre es canvia per un 2
        if (lectura[1]==["T"]||lectura[1]==["t"]){
            normalitzat[1]="2"
        }
        //P majuscula a minuscula
        if (lectura[1]==["P"]||lectura[1].match(/^(\d+)([Pp])$/)||lectura[1]==["v"]||lectura[1]==["V"]){
            normalitzat[1]="p"
        }
        
 console.log(lectura)
 console.log(normalitzat)
        return true
    }
    else{
        console.log("Estructura no vàlida:"+notacio)
        return false
    }
}
else{
    console.log("Estructura no vàlida:"+notacio)
    return false
        }
    }
)
 */
function validaCastell(){
//Comprovar que l'entrada encaixa amb Estructura + d + Pisos + Modificadors + Resultat
const lectura = notacio.match(/^([PpTtVv\d]+)(?:d|de)(\d+)([a-zABD-Z]*)(\([a-zA-Z]*\)|[C])?$/)

if (lectura){
    const valorEstructura =(
    ["T","t","P","p","V","v","2","3","4","5","6","7","8","9","10","12"].includes(lectura[1])
    ||lectura[1].match(/^(\d+)([Pp])$/)
)
    &&parseInt(lectura[2])<11; 
    // console.log(valorEstructura)
    etiqueta = lectura[1]+"d"+lectura[2]+lectura[3] 
    
    //[0]Complet [1]Estructura + [2]Pisos + [3]Modificadors + [4]Resultat
    normalitzat=lectura
    //Comprovar que la estructura sigui un caracter valid i els pisos son correctes
    for (let i=0;i<normalitzat.length;i++){
        if (normalitzat[i]==undefined){
            normalitzat[i]=""
        }
    }
    if (valorEstructura){
        //Normalitzar nomencaltura
        //Si es fa servir la nomenclatura de Torre es canvia per un 2
        if (lectura[1]==["T"]||lectura[1]==["t"]){
            normalitzat[1]="2"
        }
        //P majuscula a minuscula
        if (lectura[1]==["P"]||lectura[1].match(/^(\d+)([Pp])$/)||lectura[1]==["v"]||lectura[1]==["V"]){
            normalitzat[1]="p"
        }
        
//  console.log(lectura)
//  console.log(normalitzat)
        return true
    }
    else{
        // console.log("Estructura no vàlida:"+notacio)
        return false
    }
}
else{
    // console.log("Estructura no vàlida:"+notacio)
    return false
        }
    }

const mods = computed(()=>{
    if (validaCastell()){
    return normalitzat[3]
    }
    else{
        return ""
    }
})

const estructura=computed(()=> {
    
    if (validaCastell()){
    const mapaNotacio = {
    p:"pilar",
    v:"vano",
    2:"torre",
    3:"tres",
    4:"quatre",
    5:"cinc",
    6:"sis",
    7:"set",
    8:"vuit",
    9:"nou",
    10:"deu",
    12:"dotze"
    }

    let clau = mapaNotacio[normalitzat[1]]

    if (mods.value=="a"||mods.value=="fa"){
        //console.log("Amb agulla detectat")
    if(normalitzat[1]=="3"){
            clau='tres_agulla'
    }
    else if(normalitzat[1]=="2"){
            clau='torre_agulla'
    }
    else if(normalitzat[1]=="4"){
            clau='quatre_agulla'
    }
    else if(normalitzat[1]=="5"){
            clau='cinc_agulla'
    }
    else if(normalitzat[1]=="6"){
            clau='sis_agulla'
    }
    else if(normalitzat[1]=="7"){
            clau='set_agulla'
    }
    }
    else if (mods.value=="aa"&&normalitzat[1]=="7"){
        clau='set_agulles'
    }

    return clau}
    else{
        return "pilar"
    }
})

const pisos=computed(()=>{
    
    if (validaCastell()){
    let total = parseInt(normalitzat[2])
    let pom = estructura.value=="pilar"||estructura.value=="vano"?1:3
    let tronc = total - pom
    const mapaReforços={
        "f":1,
        "fm":2,
        "fmp":3,
        "sf":0,
        "sm":1,
        "fa":1
    }
    let reforços=mapaReforços[mods.value]||0
    return {
        total:total,
        pom:pom,
        tronc:tronc,
        reforços:reforços
    }
}

else{
    return {
        total:4,
        pom:1,
        tronc:3,
        reforços:0
    }
}}
)

const nPoms=computed(()=>{
    
    if (validaCastell()){
    if (["pilar","vano","torre","torre_agulla","tres","tres_agulla","quatre","quatre_agulla"].includes(estructura.value)){
        return 1
    }
    else if (["cinc","cinc_agulla","sis","sis_agulla","set", "set_agulla","set_agulles"].includes(estructura.value)){
        return 2}
    else if (["vuit","nou","deu","dotze"].includes(estructura.value)){
        return 3}
    else{
        return 0
    }}
    else{
        return 1
    }

})

const resultat=computed(()=>{
    
    if (validaCastell()){
    const mapaResultat={
        '':'d',
        '(c)':'c',
        'C':'c',
        '(i)':'i',
        '(id)':'id'
    }
    return mapaResultat[normalitzat[4]]
}
else{
    return "d"
}
}
)

const img=computed(()=>{
    
    if (validaCastell()){
    const mapaImg={
        pilar:"pilar",
        vano:"pilar",
        torre:"2",
        torre_agulla:"2a",
        tres:"3",
        tres_agulla:"3a",
        quatre:"4",
        quatre_agulla:"4a",
        cinc:"5",
        cinc_agulla:"5a",
        sis:"6(2+2+2)",
        sis_agulla:"6a(4+2)",
        set:"7",
        set_agulla:"7a",
        set_agulles:"7aa",
        vuit:"8(2+3+3)",
        nou:"9",
        deu:"10",
        dotze:"12(3+3+3+3)"
    }
    return mapaImg[estructura.value]+'.svg'||"pilar.svg"}
else{
    return "pilar.svg"}

})

const taula_gamma = computed(()=>{
    return uni ?  json_gamma_universitaria : json_gamma
}) 

const castell_gamma=computed(()=>{
    if (!validaCastell()){
        return taula_gamma.value['pd4']
    }
    // console.log(normalitzat[1]+"d"+normalitzat[2]+mods.value)
    // console.log(taula_gamma.value)
    // console.log(taula_gamma.value[normalitzat[1]+"d"+normalitzat[2]+mods.value])
    let base=normalitzat[1]+"d"+normalitzat[2]+mods.value
    //console.log("Buscant gamma per a: "+base)
    return taula_gamma.value[base]||{gamma:"pc"}
}
)

const gamma = computed(()=>{
    //console.log(normalitzat)
    //console.log(taula_gamma.value[normalitzat].punts_descarregat)
    if (!validaCastell()){
        return "pc"
    }
    //console.log(castell_gamma.value.gamma)
    return castell_gamma.value.gamma||"pc"
    
})

const puntuat=computed(()=>{
    if (!validaCastell()){
        return 0
    }
    if (resultat.value=="d"){
        return castell_gamma.value.punts_descarregat
    }
    else if (resultat.value=="c"){
        return castell_gamma.value.punts_carregat
    }
    else{
        return 0
    }
})

const color_gamma=computed(()=>{
    if (!validaCastell()){
        return {color:"white", text:"black"}
    }
    const mapa_color_gamma={
        b6:"white",
        a6:"grup-0",
        b7:"grup-1",
        a7:"grup-2",
        b8:"grup-3",
        a8:"grup-4",
        b9:"grup-5",
        ex:"grup-6",
        sp:"grup-7",

        b5u:"white",
        a5u:"grup-0",
        b6u:"grup-1",
        a6u:"grup-2",
        b7u:"grup-3",
        a7u:"grup-4",
        b8u:"grup-5",
        exu:"grup-6",
        spu:"grup-7",

        pc:"gray-200"
    }

    let text
    let brightness
    let format_resultat
    if ([
        "b6",
        "a6",
        "b7",
        "a7",

        "b5u",
        "a5u",
        "b6u",
        "a6u",
        "pc"

    ].includes(gamma.value)){
        text="black"
        brightness="brightness-0"
        format_resultat="bg-black text-white"
    }
    else if ([
        "b8",
        "a8",
        "b9",
        "ex",
        "sp",
        "b7u",
        "a7u",
        "b8u",
        "exu",
        "spu",
    ].includes(gamma.value)){
        text="white"
        brightness="brightness-100"
        format_resultat="bg-white text-black"
    }

    
    return {color:mapa_color_gamma[gamma.value], text:text, brightness:brightness, format_resultat:format_resultat}
    }
)

const estrelles_gamma=computed(()=>{
    if (!validaCastell()){
        return "Invalid"
    }
    const mapaEstrelles={
        b6:"⯨",
        a6:"★",
        b7:"★⯨",
        a7:"★★",
        b8:"★★⯨",
        a8:"★★★",
        b9:"★★★⯨",
        ex:"★★★★",
        sp:"★★★★★",

        b5u:"⯨",
        a5u:"★",
        b6u:"★⯨",
        a6u:"★★",
        b7u:"★★⯨",
        a7u:"★★★",
        b8u:"★★★⯨",
        exu:"★★★★",
        spu:"★★★★★",

        pc:"Per Catalogar"
}

    return mapaEstrelles[gamma.value]
})

const nom_gamma=computed(()=>{
    if (!validaCastell()){
        return "Invalid"
    }
    const mapaNomGamma={
        b6:"Bàsica de 6",
        a6:"Alta de 6",
        b7:"Bàsica de 7",
        a7:"Alta de 7",
        b8:"Bàsica de 8",
        a8:"Alta de 8",
        b9:"Bàsica de 9",
        ex:"Extra",
        sp:"Superior",

        b5u:"Bàsica de 5 Universitària",
        a5u:"Alta de 5 Universitària",
        b6u:"Bàsica de 6 Universitària",
        a6u:"Alta de 6 Universitària",
        b7u:"Bàsica de 7 Universitària",
        a7u:"Alta de 7 Universitària",
        b8u:"Bàsica de 8 Universitària",
        exu:"Extra Universitària",
        spu:"Superior Universitària",

        pc:"Per Catalogar"
    }
    return mapaNomGamma[gamma.value]
})

const nom=computed(()=>{
    if (!validaCastell()){
        return "Castell Invalid"
    }
    const mapa_e={
        pilar:"Pilar",
        vano:"Vano",
        torre:"Torre",
        torre_agulla:"Torre",
        tres:"Tres",
        tres_agulla:"Tres",
        quatre:"Quatre",
        quatre_agulla:"Quatre",
        cinc:"Cinc",
        cinc_agulla:"Cinc",
        sis:"Sis",
        sis_agulla:"Sis",
        set:"Set",
        set_agulla:"Set",
        set_agulles:"Set",
        vuit:"Vuit",
        nou:"Nou",
        deu:"Deu",
        dotze:"Dotze"
    }
    const mapa_m={
        "":"",
        "a":"amb l'agulla",
        "aa":"amb dues agulles",
        "f":"amb folre",
        "fm":"amb folre i manilles",
        "fmp":"amb folre, manilles i puntals",
        "sf":"sense folre",
        "sm":"sense manilles",
        "fa":"amb folre i l'agulla",
        "mg":"margarida",
        "d":"descargolat",
        "n":"net",
        "aco":"amb acotxaneta",
        "cam":"caminat",
        "s":"per sota"
    }

    const mapa_r={
        "d":"",
        "c":"(carregat)",
        "i":"(intent)",
        "id":"(desmuntat)"
    }

    return (mapa_e[estructura.value]||'!!Desconegut')+" de "+pisos.value.total+" "+(mapa_m[mods.value]||mods.value)+" "+mapa_r[resultat.value]
})


const color_resultat=computed(()=>{
    if (!validaCastell()){
        return "resultat-intent"
    }
    const mapa_color_resultat={
        d:"resultat-descarregat",
        c:"resultat-carregat",
        i:"resultat-intent",
        id:"resultat-desmuntat"}
    return mapa_color_resultat[resultat.value]
}
)

validaCastell()
// console.log("Etiqueta:"+etiqueta)
// console.log("Norm:"+normalitzat)

    return {
        //Basic
        etiqueta:etiqueta, //Entrada de l'Usuari
        normalitzat:normalitzat, //Estandar Mosaic Casteller
        gamma:gamma.value, //Identificador de gamma, str
        
        //Specs
        estructura:estructura.value, //Normalitzada, str
        nPoms:nPoms.value, //Nombre de poms, int
        pisos:pisos.value.total, //Int
        pom:pisos.value.pom, //Pisos del pom
        tronc:pisos.value.tronc, //Pisos del tronc
        reforços:pisos.value.reforços, //Nombre de reforços
        mods:mods.value, //S'accepten mods no llegits
        resultat:resultat.value, //Normalitzat, str
        punts:{descarregat:castell_gamma.value.punts_descarregat, carregat:castell_gamma.value.punts_carregat},
        puntuat:puntuat.value,

        //Format
        img:img.value, //Ruta del esquema de l'estructura
        color:{ 
            gamma:color_gamma.value.color,
            text:color_gamma.value.text,
            brightness:color_gamma.value.brightness,
            format_resultat:color_gamma.value.format_resultat,
            resultat:color_resultat.value,
            text_resultat:"white"
        }, //Color de la gamma, no del resultat
        nom:nom, //Complet, format [Estructura (recdactat)] + de + [pisos] + (amb) + [mods (redactat)] + ([resultat])
        nom_gamma:nom_gamma.value, //Nom de la gamma, [Alta/Basica] de [Pisos] o [Extra/Superior], Universitaria o No
        estrelles:estrelles_gamma, //Nombre d'estrelles de la gamma

        //Meta
        valid:validaCastell(), //Boolea de validacio
        uni:uni //Boolea d'universitaria
}
}


